/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';

import { renderTextField } from '../components/reduxFields';
import SortingCustom from '../components/SortingCustom';
import { showFormatedDate, base64Encode, resetFiltersAndSorting } from '../actions/utilAction';
import PaginatorCustom from '../components/paginationCustom';
import { getClientDocuments } from '../modules/Dashboards/actions/StaffDashboardActions';

/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class ClientDocuemntsTable extends Component {

  constructor(props) {
    super(props);
    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    this.handleSearchPatientDocs = this.handleSearchPatientDocs.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadPatientDocuments(page_number) {
    let searchObj1 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || '', viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission ? '1' : '0' },
    };
    this.props.SendQueryparams(searchObj1)
    this.props.getClientDocuments(searchObj1);
  }

  handleSearchPatientDocs() {
    return false;
  }

  handleReset = () => {
    this.props.dispatch(reset('ClientDocuemntsTable'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadPatientDocuments();
  };

  handleSearchChange(event) {
    if (event.target.value.length > 0) {
      this.filter.searchText = event.target.value;
      this.loadPatientDocuments();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadPatientDocuments();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadPatientDocuments();
    }
  }


  showTableData() {
    return this.props.ClientDocmuents.data.map((data) => {
      let patientId = base64Encode(`${data.patientId}`);
      return (
        <TableRow key={data.authorizationId} style={{ background: `${data.warningColorCode}` }}>
          {/* <TableRowColumn style={{width : '35%'}}>{data.patientName}</TableRowColumn> */}
          <TableRowColumn style={{ width: '35%' }}><NavLink to={`/client/documents/${patientId}`} exact >{data.patientName}</NavLink></TableRowColumn>
          <TableRowColumn style={{ width: '40%' }}>{data.otherDocumentType ? 'Other (' + data.otherDocumentType + ')' : data.documentTypeName}</TableRowColumn>
          <TableRowColumn style={{ width: '25%' }}>{showFormatedDate(data.expiration)}</TableRowColumn>
        </TableRow>
      );
    });
  }

  render() {
    const { handleSubmit, ClientDocmuents } = this.props;
    const patientDocsList =  (ClientDocmuents && ClientDocmuents.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div className="row end-flex">
              <div className="col-sm-9 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchPatientDocs)}>
                  <Field
                    name="patientDocs"
                    floatingLabelText="Search"
                    maxLength='25'
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-3 btn_rt">
                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow >
              <TableHeaderColumn style={{ width: '35%' }}>
                <SortingCustom noSort={!patientDocsList.length} setSortColumn={this.setSortColumn} columnName='patientName' displayName='Client Name' />
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '40%' }}>Document Type</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '25%' }}>Expiration Date</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.ClientDocmuents && this.props.ClientDocmuents.data && this.props.ClientDocmuents.data.length > 0 ?
              this.showTableData()
              :
              <TableRow>
                <TableRowColumn colSpan="3">No Record Found</TableRowColumn>
              </TableRow>
            }
          </TableBody>
        </Table>
        {this.props.ClientDocmuents.data && this.props.ClientDocmuents.data.length ?
          <PaginatorCustom data={this.props.ClientDocmuents.meta} handlePageChange={(page_number) => this.loadPatientDocuments(page_number)} />
          : null}
      </div>
    );
  }
}

ClientDocuemntsTable = reduxForm({
  form: 'ClientDocuemntsTable',
})(ClientDocuemntsTable);

function mapStateToProps(state) {
  //  console.log('state.patient_dashboard.PatientDocuments..............', state.patient_dashboard ? state.patient_dashboard.PatientDocuments : {},);
  return {
    ClientDocmuents: state.staff_dashboard ? state.staff_dashboard.ClientDocuments : {},
    LeftPanel_loading: state.staff_dashboard.LeftPanel_loading,
  };
}

export default connect(mapStateToProps, { getClientDocuments })(ClientDocuemntsTable);



// WEBPACK FOOTER //
// ./src/adminCharts/ClientDocuemntsTable.js